import { normalizeDates as i } from "./_lib/normalizeDates.js";
import { startOfWeek as r } from "./startOfWeek.js";
function o(t, a, e) {
  const [m, f] = i(
    e?.in,
    t,
    a
  );
  return +r(m, e) == +r(f, e);
}
export {
  o as default,
  o as isSameWeek
};
